module.exports = __webpack_public_path__ + "img/ring_y_s_0_0@2x.4adaf3f1.png";